import React from "react";

// A member's profile photo, or their initials on the brand gradient when they have not uploaded one.
export default function Avatar({ src, name = "", size = 64, className = "" }) {
  const initials = name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase()).join("") || "?";
  const style = { width: size, height: size, fontSize: Math.max(12, Math.round(size * 0.36)) };
  if (src) {
    return <img src={src} alt={name} style={style} className={`rounded-full object-cover border-2 border-accent-light/40 shrink-0 ${className}`} />;
  }
  return (
    <span style={style} className={`rounded-full bg-brand-gradient flex items-center justify-center font-bold text-white shrink-0 ${className}`}>
      {initials}
    </span>
  );
}
